module.exports = __webpack_public_path__ + "img/fig21.24372523.jpg";